<template>
  <div>
    <ul class="icon-list" v-if="list.length">
      <li style="cursor: pointer" @click="goDetailLoc(item.code, item.offsetY)" :key="index" v-for="(item, index) in list" :style="{marginBottom: marginBottom + 'rem'}">
        <div class="icon">
          <img :src="item.listIcon" />
        </div>
        <div class="text">{{ item.listName }}</div>
      </li>
    </ul>
    <ul class="icon-list" v-if="rankList.length">
      <li :key="index" v-for="(item, index) in rankList" :style="{marginBottom: marginBottom + 'rem'}">
        <div class="icon">{{index + 1}}</div>
        <div class="text">{{ item.listName}}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'IconList',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    rankList: {
      type: Array,
      default() {
        return []
      }
    },
    marginBottom: {
      type: Number,
      default: 0.4
    }
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    goDetailLoc(code, val) {
      if(val) {
        this.$store.commit("setChildModalOffsetY", val);
      } else {
        this.$store.commit("setChildModalOffsetY", 0);
      }
      this.$store.commit("setChildModalTitle", this.title);
      this.$store.commit("setChildModalCode", code);
      this.$store.commit("setChildModalShow");
    }
  }
}
</script>

<style scoped lang="less">
.icon-list {
  margin-top: 0.14rem;
  width: 100%;
  li {
    width: 50%;
    height: 0.54rem;
    float: left;
    background-image: linear-gradient(
      to right,
      rgba(2, 183, 234, 0.2),
      rgba(2, 183, 234, 0)
    );
    border-radius: 0.1rem;
    > div {
      float: left;
      height: 100%;
    }
    .icon {
      width: 0.54rem;
      border: 1px solid #02b7ea;
      border-radius: 0.1rem;
      font-family: 'lcd';
      line-height: 0.46rem;
      font-size: 0.5rem;
      font-weight: bold;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    .text {
      width: calc(3.9rem / 2 - 0.54rem);
      line-height: 0.54rem;
      font-size: 0.2rem;
      text-align: left;
      padding-left: 0.2rem;
      box-sizing: border-box;
    }
    .down-bar {
      height: 0.09rem;
      border-left: #02d5f8 1px solid;
      border-right: #02d5f8 1px solid;
      position: relative;
    }
    .down-bar::after {
      content: '';
      width: 100%;
      height: 1px;
      background: #02d5f8;
      position: absolute;
      left: 0;
      bottom: 0.04rem;
    }
  }
}

@media screen and (max-height: 863px) {
  ul li {
    margin-bottom: 0.2rem;
  }
}
</style>
